/* eslint-disable no-restricted-syntax */
import { State } from "../types/BaseContext.types";
import Topic from "../types/Topic.interface";

const constructFileName = (title: string) => {
  const formattedDate = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const dateParts: any = {};

  formattedDate.formatToParts(new Date()).forEach(({ type, value }) => {
    dateParts[type] = value;
  });

  const formattedTitle = title.replace(" ", "").toLowerCase();

  return `threatcheck_${formattedTitle}-files_${dateParts.year}-${dateParts.month}-${dateParts.day}_${dateParts.hour}-${dateParts.minute}.zip`;
};

const requestAndDownloadPolicyPackage = async (
  topic: Topic,
  baseState: State
) => {
  /**
   * Filter the needed Questions for the Topic from the BaseContext
   * and only submit those to backend for Poster and Policy Creation
   */
  const questionIds = topic.questions.map((question) => question._id);
  const topicQuestions: any = {};

  for (const questionId of Object.keys(baseState)) {
    if (questionIds.indexOf(questionId) >= 0) {
      topicQuestions[questionId] = baseState[questionId];
    }
  }

  const submitData = {
    category: topic._id,
    data: topicQuestions,
  };

  const policyPackage = await fetch("/api/v1/poster", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(submitData),
  });

  const url = window.URL.createObjectURL(await policyPackage.blob());
  const a = document.createElement("a");
  a.href = url;
  a.download = constructFileName(topic.title);
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export default requestAndDownloadPolicyPackage;
